import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel on mount
    initPixel();
  }, []);
  return <SalesPage data-id="element-0" />;
}